import { ECategoriesThemes, ICategory, ICategoryThemeSetting } from "./typings";

export const CATEGORIES_THEMES_SETTINGS: ICategoryThemeSetting[] = [
  {
    name: ECategoriesThemes.teal,
    gradient: ['#0D8390', '#3EFAC5'],
    guidance: '#DEF0EF',
    policies: '#C9E7E5',
    tooltipPreview: {
      borderColor: '#007680',
      shadowColor: 'rgba(0, 163, 224, 0.21)'
    }
  },
  {
    name: ECategoriesThemes.blue,
    gradient: ['#007CB0', '#33F0FF'],
    guidance: '#F0F9FF',
    policies: '#DDEFFF',
    tooltipPreview: {
      borderColor: '#007CB0',
      shadowColor: 'rgba(0, 163, 224, 0.21)'
    }
  },
  {
    name: ECategoriesThemes.green,
    gradient: ['#26890D', '#0DF200'],
    guidance: '#F8FFF6',
    policies: '#D7F0C8',
    tooltipPreview: {
      borderColor: '#26890D',
      shadowColor: 'rgba(30, 176, 9, 0.20)'
    }
  },
  {
    name: ECategoriesThemes.yellow,
    gradient: ['#ED8B00', '#FFCD00'],
    guidance: '#FFFEE7',
    policies: '#FCEFDB',
    tooltipPreview: {
      borderColor: '#ED8B00',
      shadowColor: 'rgba(237, 139, 0, 0.15)'
    }
  },
  {
    name: ECategoriesThemes.violet,
    gradient: ['#344297', '#D3DCFF'],
    guidance: '#EDF1FF',
    policies: '#D3DCFF',
    tooltipPreview: {
      borderColor: '#4250A1',
      shadowColor: 'rgba(71, 85, 164, 0.19)'
    }
  },
];
